import { BelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';
import { FormFields } from 'src/modules/user-input/FormFieldNames.ts';
import { getUserInputFormFieldKey } from 'src/modules/common/hooks/getUserInputFormFieldKey.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { UserInput } from 'src/modules/user-input/types.ts';
import { ValveProduct } from 'src/modules/valves/ValvesPageMapping.ts';
import { RegionsEnum } from 'src/generated/operations.ts';

type Props = {
    userInputState: UserInput;
    valve: ValveProduct;
    translate: BelimoTranslate;
    region: RegionsEnum;
}

const fields: FormFields[] = ['v100'];

export const buildDesignDataContent = ({ userInputState, valve, translate, region }: Props) => [
    ...(fields
        .filter((name) => userInputState[name])
        .map((name) => [
            translate(getUserInputFormFieldKey(region, name), false),
            userInputState[name],
            translate(userInputState[`${name}_u`]),
        ].join(' '))),
    ...([
        [MESSAGES.EffectiveDpv, valve.calcEffectiveDpv],
        [MESSAGES.MinReqDpv, valve.calcMinReqDpv],
        [MESSAGES.EffectivePV, valve.calcEffectivePV],
        [MESSAGES.FlowVelocity, valve.calcFlowVelocity],
    ].filter(([, v]) => v)
        .map(([k, v]) => `${translate(k)} ${v}`)
    ),
].join(', ');
